import { render, staticRenderFns } from "./LogsComp.vue?vue&type=template&id=0da30922&scoped=true&"
import script from "./LogsComp.vue?vue&type=script&lang=js&"
export * from "./LogsComp.vue?vue&type=script&lang=js&"
import style0 from "./LogsComp.vue?vue&type=style&index=0&id=0da30922&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da30922",
  null
  
)

export default component.exports